import React from 'react'
import { Link } from 'react-router-dom'
import bgmask from '../Components/images/bgmask.jpg'
import circle from '../Components/images/circle.jpg'
import grass from '../Components/images/grass.png'

const Story = () => {
    return (
        <>
            <div className="container md:mx-10 py-2 justify-center ">
                <div className=" bg-[#F1F2F2] ">
                    <div className="md:w-[56%]  w-full md:left-[24%]   top-0 bottom-0 relative">
                        <div className="md:mx-0 mx-4">
                            <div className="py-12">
                                <h1 className='text-[2.5rem] font-black text-[#004A8B]'>Our Story</h1>
                                <h1 className='border-b-[.4rem] border-[#B5D1B3] w-[3.5rem]'></h1>
                            </div>
                            <div className="">
                                <p className='md:text-[1.5rem] text-[1.2rem] font-black text-[#004A8B] tracking-wider leading-8'>
                                    LAWD is a tier-one firm in the Australian property market providing a full suite of professional real estate services including advisory, transactions and valuations, with specialist expertise in the development, land and agribusiness sectors.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="md:flex  justify-between  items-center mx-8 ">
                        <div className="img md:w-[50%] mt-[4rem]">
                            <img src={bgmask} alt="pic" className='  h-[100%]' />
                        </div>

                        <div className="md:mx-10 md:w-[50%]">

                            <img src={circle} alt="circle" className="rounded-full my-10 md:my-20" />


                            <p className='tracking-wideer leading-7 py-10'>Founded in 2020, our young and dynamic company was established by some of the most respected names in the industry and is powered by a cumulative expertise and on-the-ground experience that equates to centuries of knowledge and insight.</p>
                            <p className='tracking-wideer leading-7'>
                                We have grown to a team of more than 50 specialist staff with offices across the country, rapidly building an enviable reputation in Australia's property sector for excellence, trust, reliability and results.
                            </p>

                            <p className='tracking-wideer leading-7 py-10'>However, it's not just optimal outcomes that we deliver for our clients. We build authentic connections and partnerships that go far beyond the financial transaction. Our network of relationships also means we can efficiently match buyers with sellers and connect our customers with expertise within our own business</p>

                        </div>

                    </div>

                    <div className="md:flex justify-between   py-5 ">
                        <div className="w-[100%] md:mx-20  md:my-[10rem]">
                            <p className='tracking-wider leading-7 md:mx-0 mx-4 text-[16px]'>As a fully integrated property, advisory and valuation firm, our team of specialists collaborates on each engagement and across the country. We service everywhere from the urban fringes of our biggest metropolitan cities, through to the great expanses of Australia's most rural and remote regions.</p>

                            <p className='py-10 text-[1.6rem] md:mx-0 mx-4 text-[#004A8B] font-black
                            '>At LAWD, our knowledge and insight accelerates your success.</p>

                            <button className='border text-[12px] md:mx-0 mx-4 px-5 tracking-wider py-3 bg-[#004A8B] border-[#004A8B] text-white hover:border-[#B5D1B3] hover:bg-[#B5D1B3] hover:text-[#004A8B]  '><Link>VIEW OUR TEAM</Link></button>
                        </div>
                        <div className="w-[100%]  beger">
                            <img src={grass} alt="" className='md:my-20 my-10' />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Story
